import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { DECLINATION_QUERY } from "Configs/queries";
import withDefaultParams from "Services/withDefaultParams";

const DeclinationContainerNew = props => {
    let regionUrl = props.currentRegionUrl
        ? props.currentRegionUrl
        : props.match.params.regionUrl;
    const { data } = useQuery(DECLINATION_QUERY, {
        skip: !regionUrl,
        variables: {
            filter: `url=${regionUrl}`,
        },
    });

    const declinations = data?.region?.declinations;

    if (!declinations) {
        return null;
    }

    return React.cloneElement(props.children, {
        declinations: declinations,
    });
};

export default withRouter(withDefaultParams(DeclinationContainerNew));
